import React from "react";

export const BackgroundSvg = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1512 982"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <g clipPath="url(#clip0_1377_9513)">
        <rect width="1512" height="982" fill="white" />
        <g filter="url(#filter0_f_1377_9513)">
          <ellipse cx="707" cy="439.5" rx="982" ry="983.5" fill="#FAD9B5" />
        </g>
        <g filter="url(#filter1_f_1377_9513)">
          <circle cx="147" cy="1500" r="689" fill="#A6EBE3" />
        </g>
        <g filter="url(#filter2_f_1377_9513)">
          <ellipse
            cx="1031.5"
            cy="1079.5"
            rx="657.5"
            ry="507.5"
            fill="#61C4E8"
          />
        </g>
        <g filter="url(#filter3_f_1377_9513)">
          <ellipse cx="1689" cy="579.5" rx="602" ry="184.5" fill="#E3C2F5" />
        </g>
        <g filter="url(#filter4_f_1377_9513)">
          <ellipse cx="233" cy="36" rx="443" ry="162" fill="white" />
        </g>
        <g filter="url(#filter5_f_1377_9513)">
          <ellipse cx="1357" cy="-102.5" rx="443" ry="232.5" fill="white" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_1377_9513"
          x="-575"
          y="-844"
          width="2564"
          height="2567"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_1377_9513"
          />
        </filter>
        <filter
          id="filter1_f_1377_9513"
          x="-1042"
          y="311"
          width="2378"
          height="2378"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="250"
            result="effect1_foregroundBlur_1377_9513"
          />
        </filter>
        <filter
          id="filter2_f_1377_9513"
          x="-126"
          y="72"
          width="2315"
          height="2015"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="250"
            result="effect1_foregroundBlur_1377_9513"
          />
        </filter>
        <filter
          id="filter3_f_1377_9513"
          x="687"
          y="-5"
          width="2004"
          height="1169"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="200"
            result="effect1_foregroundBlur_1377_9513"
          />
        </filter>
        <filter
          id="filter4_f_1377_9513"
          x="-510"
          y="-426"
          width="1486"
          height="924"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_1377_9513"
          />
        </filter>
        <filter
          id="filter5_f_1377_9513"
          x="614"
          y="-635"
          width="1486"
          height="1065"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_1377_9513"
          />
        </filter>
        <clipPath id="clip0_1377_9513">
          <rect width="1512" height="982" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
